import styled from '@emotion/styled';

/**
 * @param {user} User 정보 객체 (user: {profile_image_url, name})
 * @returns 프로필 이미지와 이름으로 구성된 간단한 User 프로필 뷰
 */
function UserProfileSimple({user, isActive, isNameOnly}) {
    if (!user) return null
    return (
        <UserInfoContainer>
            <UserImg
                src={process.env.REACT_APP_RES_PATH + user.profile_image_url}
                isActive={isActive}
                alt="Knotter 이미지"
                onError={e => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = "/image/icn_profile_image_default.svg"
                }}
            />
            { isNameOnly ? (
                    <Info>{user.name}</Info>    
                ) : (
                    <Info>{user.name} <span id='name-ko'>({user.name_ko})</span> <span id="email">{user.email}</span></Info>
                ) 
            }
        </UserInfoContainer>
    )
}

const UserInfoContainer = styled.div`
    display: flex;
	align-items: center;
	gap: 10px;
`

const UserImg = styled.img`
    width: 30%;
    max-width: 40px;
    aspect-ratio: 1/1;
    border: 1px solid var(--main-dark-color);
    border-radius: 20px;
    margin-left: 10px;
    object-fit: cover;
    filter: ${props => props.isActive === '0' ? 'grayscale(100%)' : 'none'};
`

const Info = styled.div`
  font-family: 'Gotham';
  font-size: 16px;
  line-height: 1;

  #name-ko {
    font-family: 'Pretendard';
    font-size: 14px;
    color: var(--gray-color);
  }

  #email {
    font-weight: 300;
    color: #66666699;
    margin-left: 8px;
  }
`

export default UserProfileSimple